import { useCallback } from 'react';

type InteractionHandler = (
  event: React.MouseEvent | React.KeyboardEvent
) => void;

export const useInteraction = (
  callback: (event: React.MouseEvent | React.KeyboardEvent) => void,
  keys: string[] = ['Enter']
): InteractionHandler => {
  return useCallback(
    (event: React.MouseEvent | React.KeyboardEvent) => {
      if (
        event.type === 'click' ||
        (event.type === 'keydown' &&
          keys.includes((event as React.KeyboardEvent).key))
      ) {
        event.preventDefault();
        callback(event);
      }
    },
    [callback, keys]
  );
};
